import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { TitleText } from '../Teams/style/RegisteredTeamsStyle';
import { trackEventMatomo } from '../../helpers/matomo';
import { Button, Card } from '@mui/material';
import HeaderModal from '../HeaderModal/HeaderModal';

export default function ModalDeny({
  mutate,
  status,
  openRefuse,
  setOpenRefuse,
}: {
  mutate: Function,
  status: string,
  openRefuse: boolean,
  setOpenRefuse: Function,
}) {
  const { t } = useTranslation('translation');

  const escape = useCallback((e: any): void => {
    if (e.key === 'Escape' && openRefuse) {
      setOpenRefuse();
    }
  }, [openRefuse, setOpenRefuse]);

  const close = () => {
    trackEventMatomo('modal recusa chamado', 'click', 'div', 'fecha modal');
    setOpenRefuse();
  };

  return (
    <Card>
      <TitleText>
        <div className={`modal ${openRefuse ? "modal is-active" : "modal"}`}>
          <div className="modal-background"
            onKeyDown={() => {
              trackEventMatomo('modal recusa chamado', 'click', 'div', 'fecha modal');
              escape(true);
            }} onClick={close} />
          <div className="modal-card" onSubmit={(e: React.FormEvent) => e.preventDefault()}>
            <HeaderModal headerTitle={`${t('notifications.ticket.doYouWant')} 
              ${status === 'recusado'
                ? `${t('notifications.ticket.reject')}`
                : `${t('notifications.ticket.cancel')}`} 
              ${t('notifications.ticket.executionOfThisTicket')}`} close={close} />
            <div style={{ display: 'flex', justifyContent: 'center' }} className="modal-card-body">
              <Button
                endIcon={<DoNotDisturbIcon />}
                className='button is-danger'
                onClick={() => {
                  trackEventMatomo('modal recusa chamado', 'click', 'button', 'salva');
                  mutate();
                }}>
                {status === 'recusado' ? 'recusar' : 'cancelar'}
              </Button>
            </div>
          </div>
        </div>
      </TitleText>
    </Card>
  );
}
